import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export type FormHiddenInputProps = React.InputHTMLAttributes<HTMLInputElement> & ControllerProps;

export const FormHiddenInput = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormHiddenInputProps) => {
    const { value, handleChange } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        name,
        value,
    };

    return <input type="hidden" {...props} onChange={(e) => handleChange(e, e.target.value)} />;
};
